<template>
  <!-- Navbar -->
  <nav
    class="top-0 navbar navbar-expand-lg position-absolute z-index-3"
    :class="isBlur ? isBlur : 'shadow-none my-2 navbar-transparent w-100'"
  >
    <div class="container">
      <router-link
        class="navbar-brand font-weight-bolder ms-lg-0 ms-3"
        to="/dashboard"
        v-bind="$attrs"
        :class="isBlur ? 'text-dark' : 'text-white'"
      >
        导航入口
      </router-link>
      <button
        class="navbar-toggler shadow-none ms-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navigation"
        aria-controls="navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon mt-2">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <router-link
              class="nav-link d-flex align-items-center me-2 active"
              aria-current="page"
              to="/dashboard"
            >
              <i
                class="fa fa-chart-pie opacity-6 me-1"
                aria-hidden="true"
                :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              进控制台
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link me-2" to="/profile">
              <i
                class="fa fa-user-shield opacity-6 me-1"
                aria-hidden="true"
                :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              平台简介
            </router-link>
          </li>
          <!--
          <li class="nav-item">
            <router-link class="nav-link me-2" to="/sign-up">
              <i
                class="fas fa-user-circle opacity-6 me-1"
                aria-hidden="true"
                :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              Sign Up
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link me-2" to="/sign-in">
              <i
                class="fas fa-key opacity-6 me-1"
                aria-hidden="true"
                :class="isBlur ? 'text-dark' : 'text-white'"
              ></i>
              Sign In
            </router-link>
          </li>-->
        </ul>
        <ul class="navbar-nav d-lg-block d-none">
          <li class="nav-item">
            <a
              href="#"
              class="btn btn-sm btn-round mb-0 me-1"
              :class="isBlur ? 'bg-gradient-dark' : 'bg-gradient-success'"
              @click="showQRCode"
              >联系客服了解更多</a
            >
          </li>
        </ul>

        <!-- Qrcode Popup -->
        <div v-if="isQRCodeVisible" class="qrcode-popup">
          <div class="qrcode-overlay" @click="hideQRCode"></div>
          <div class="qrcode-content" :style="popupStyle">
            <img :src="qrCodeImage" alt="二维码" />
            <p>扫描二维码联系我们</p>
          </div>
        </div>

      </div>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import downArrWhite from "@/assets/img/down-arrow-white.svg";
import downArrBlack from "@/assets/img/down-arrow-dark.svg";
import QRCode from 'qrcode';

export default {
  name: "navbar",
  data() {
    return {
      downArrWhite,
      downArrBlack,
      isQRCodeVisible: false, // 控制二维码显示的标识
      qrCodeImage: '', // 存储二维码图片的URL
      buttonRect: {}, // 按钮的位置及大小
    };
  },
  props: {
    btnBackground: String,
    isBlur: String,
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  methods:{
    // 显示二维码的方法
        showQRCode() {
          const qrData = "358502asdfasdfasdfsdf56"; // 二维码的内容
          QRCode.toDataURL(qrData, { errorCorrectionLevel: 'H' })
            .then((url) => {
              this.qrCodeImage = url; // 生成的二维码图片的URL
              this.isQRCodeVisible = true; // 显示二维码弹框
              // 获取按钮的位置，用于计算二维码弹出的相对位置
              //this.buttonRect = event.target.getBoundingClientRect();
            })
            .catch((err) => {
              console.error("二维码生成失败", err);
            });
        },
        // 隐藏二维码的方法
        hideQRCode() {
          this.isQRCodeVisible = false; // 隐藏二维码弹框
        }
  },
  computed: {
    darkModes() {
      return {
        "text-dark": this.darkMode,
      };
    },
    // 计算弹出二维码的位置
    popupStyle() {
      // 确保二维码的位置不溢出视口
      let topPosition = this.buttonRect.bottom + window.scrollY + 10;  // 按钮下方的位置
      let leftPosition = this.buttonRect.left + window.scrollX; // 按钮左边的位置

      // 防止二维码超出屏幕右侧
      if (leftPosition + 150 > window.innerWidth) {  // 150是二维码的宽度
        leftPosition = window.innerWidth - 150; // 调整二维码到屏幕右边缘
      }

      // 防止二维码超出屏幕底部
      if (topPosition + 150 > window.innerHeight) {  // 150是二维码的高度
        topPosition = window.innerHeight - 150; // 调整二维码到屏幕底部
      }

      return {
        top: `${topPosition}px`,
        left: `${leftPosition}px`,
      };
    },
  },
};
</script>

<style scoped>
/* 样式：二维码弹窗 */
.qrcode-popup {
  position: absolute;
  z-index: 1050;
  width: auto;
}

.qrcode-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 背景遮罩 */
  cursor: pointer;
  border-radius: 50px; /* 圆角 */
  z-index: 1040; /* 确保遮罩在弹窗下方 */
}

.qrcode-content {
  position: fixed; /* 使用fixed定位让它固定在页面中 */
  top: 500%; /* 距离页面顶部50% */
  left: 50%; /* 距离页面左侧50% */
  transform: translate(-50%, -50%); /* 通过transform使弹窗真正居中 */
  background-color: white;
  padding: 20px;
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  z-index: 1050; /* 确保弹窗在遮罩层上方 */
}

.qrcode-content img {
  width: 150px; /* 二维码图片大小 */
  height: 150px;
}

.qrcode-content p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}
</style>